import { createSlice } from "@reduxjs/toolkit";

const selectedCustomerContactSlice = createSlice({
  name: "selectedCustomerContact",
  initialState: null,
  reducers: {
    setSelectedCustomerContact: (state, action) => {
      return action.payload;
    },
    clearSelectedCustomerContact: () => {
      return null;
    },
  },
});

export const { setSelectedCustomerContact, clearSelectedCustomerContact } =
  selectedCustomerContactSlice.actions;
export const selectedSelectedCustomerContact = (state) =>
  state.selectedCustomerContact;

export default selectedCustomerContactSlice.reducer;
